import "./NonQualifiedItemsPanel.scss";

import { useEffect, useState } from "react";
import AdvancedTextArea from "components/inputs/TextArea/AdvancedTextArea";
import SummaryEmptyState from "./SummaryEmptyState";

import type { NonQualifiedItem } from "../../hooks/ai-insights/useNonQualifiedItemsDocuments";

type NonQualifiedItemsPanelProps = {
  items: NonQualifiedItem[];
  emptyMessage: string;
  isEditable?: boolean;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
};

const NonQualifiedItemsPanel = ({
  items,
  emptyMessage,
  isEditable = true,
  isCollapsed = false,
  onToggleCollapse,
}: NonQualifiedItemsPanelProps) => {
  const hasContent = items.length > 0;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`metadoc-ai-summary non-qualified-items-panel ${isVisible ? "metadoc-ai-summary--visible" : ""} ${isCollapsed ? "non-qualified-items-panel--collapsed" : ""}`}
    >
      {!hasContent ? (
        <SummaryEmptyState message={emptyMessage} />
      ) : (
        <>
          <div className="metadoc-ai-summary__header">
            <div className="metadoc-ai-summary__badge">
              <span className="material-icons">auto_awesome</span>
              <span className="metadoc-ai-summary__badge-text">
                AI Generated Summary
              </span>
            </div>
            <div className="metadoc-ai-summary__header-actions">
              <button
                className="metadoc-ai-summary__collapse-btn"
                onClick={() => onToggleCollapse?.()}
                title={isCollapsed ? "Expand summary" : "Collapse summary"}
              >
                <span className="material-icons">
                  {isCollapsed ? "expand_more" : "expand_less"}
                </span>
              </button>
            </div>
          </div>

          {!isCollapsed && (
            <div className="non-qualified-items-panel__content">
              {items.map((item, index) => (
                <div
                  key={item.id}
                  className={`non-qualified-items-panel__section${index > 0 ? " non-qualified-items-panel__section--divided" : ""}`}
                >
                  <div className="non-qualified-items-panel__section-header">
                    <span className="non-qualified-items-panel__section-title">
                      Entry {index + 1}
                    </span>
                    <div className="metadoc-ai-summary__context non-qualified-items-panel__date-context">
                      <span className="metadoc-ai-summary__context-title">
                        Date
                      </span>
                      <input
                        type="date"
                        className="non-qualified-items-panel__date-input"
                        value={item.date}
                        onChange={(e) => item.onDateChange(e.target.value)}
                        onBlur={() => void item.onDateBlurSave()}
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                  <div className="non-qualified-items-panel__section-content">
                    <AdvancedTextArea
                      value={item.content}
                      name={`non-qualified-item-${item.id}`}
                      onChange={item.onChange}
                      onBlur={() => void item.onBlurSave()}
                      isEditable={isEditable}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NonQualifiedItemsPanel;
